import React, {Component} from 'react';
import {Col, Container, Media, Row,} from "reactstrap";
import assets from "../../../util/assets";
import "./index.css";
import "../common.css";
import {vuePayLog} from "../../../util/utility";
import moment from "moment/moment";
import className from "classnames";

export default class TipComponent extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    getTipData = (key, defaultValue) => {
        let value = this.props.tip &&
            this.props.tip.tipDataList &&
            this.props.tip.tipDataList.data[key];

        if (!value) {
            value = defaultValue;
        }
        return value;
    };

    render() {

        return (
            <div className={className({"chat-component-container": this.props.showHeader})}>
                {
                    this.props.showHeader &&
                    <div>
                        <Row className="chat-component-header-container">
                            <Col className="chat-component-header">Likes</Col>
                            <Col className="chat-component-header-close">
                                <img src={assets.broadcast.cross}
                                     onClick={() => {
                                         vuePayLog("TipComponent", "", "Cross icon clicked");
                                         this.props.setRightLayout("");
                                     }}
                                     alt="cross icon"
                                     width={13}/>
                            </Col>
                        </Row>
                        <div className="chat-component-header-divider "/>
                    </div>
                }
                <div className="chat-component-main-content-container">
                    <Container style={{textAlign: 'center'}}>
                        <img
                            src={assets.tip_not_selected}
                            alt="tip donate icon"
                            style={{height: "66.91px", width: "64px"}}
                            className="mt-4 mb-2"
                        />
                        <p className="total-tip-received">Total Like Received</p>
                        <p className="totalTipValue">
                            {this.getTipData("total_tip_amount_formatted", "£ 0.00")}
                        </p>
                    </Container>
                    <Container className="no-margin no-padding">
                        <Row className="mx-0">
                            <Col md="8" sm="8" className="text-left no-padding">
                                <p
                                    style={{paddingLeft:16}}
                                    className="tip-contributors-text"
                                >
                                    Like Contributors ({this.getTipData("total_contributors", 0)})
                                </p>
                            </Col>
                        </Row>
                        <div className="chat-component-header-divider "/>
                        {
                            this.getTipData("total_contributors", 0) === 0 &&
                            <Row className="mx-0">
                                <Col md="8" sm="8" className="tip-list-empty-state">
                                    <img alt="Empty state" src={assets.tip_empty_state}/>
                                    <p className="tip-list-empty-state-text">Looks like you didn’t get any likes yet,
                                        keep promoting…</p>
                                </Col>
                            </Row>
                        }

                        <div style={{overflowY: "auto"}}>
                            {this.props.tip &&
                            this.props.tip.tipDataList &&
                            this.props.tip.tipDataList.data.tips.map((tip, index) => (

                                <div key={`tip-item-${index}`}>
                                    {
                                        index !== 0 && <div className="tip-list-seperator"/>
                                    }
                                    <Media
                                        style={{height: 53}}
                                        className={
                                            this.props.tip &&
                                            this.props.tip.tipDataList &&
                                            this.props.tip.tipDataList.data.tips.length == 1
                                                ? "p-2 box-for-img-span no-margin no-padding tip-item"
                                                : " p-2 box-for-img-span no-margin no-padding tip-item"
                                        }
                                    >
                                        <Media left middle href="#" className="position-relative">
                                            <Media
                                                object
                                                src={
                                                    tip.profile_pic != null
                                                        ? tip.profile_pic
                                                        : assets.user_placeholder
                                                }
                                                alt="Generic placeholder image"
                                                style={{width: "40px", height: "40px"}}
                                                className="rounded-circle"
                                            />
                                            {tip.is_favourite ? (
                                                <div
                                                    style={{
                                                        width: "11px",
                                                        height: "11px",
                                                        //borderRadius: "50%",
                                                        backgroundImage: `url(${assets.favourite_icon_enabled})`,
                                                        backgroundRepeat: "no - repeat",
                                                        //border: "1px solid #FFFFFF",
                                                        bottom: "0px",
                                                        left: "30px",
                                                        position: "absolute",
                                                        zIndex: "99",
                                                        backgroundSize: "cover",
                                                    }}
                                                ></div>
                                            ) : (
                                                ""
                                            )}
                                        </Media>
                                        <Media body style={{height: 40}}>
                                            <Row className="mx-0">
                                                <Col md="9" sm="9" className="text-left">
                                                    <Media heading
                                                           className="text-left tipUserName text-uppercase no-margin no-padding">
                                                        {tip.username}
                                                    </Media>
                                                    <span className="has-donates-tip">
                                                    has liked
                                                  </span>
                                                    <span className="min-ago">
                            &nbsp;&nbsp;&nbsp;&nbsp;.{" "}
                                                        {moment
                                                            .utc(
                                                                moment(
                                                                    moment.utc().format("HH:mm:ss a"),
                                                                    "HH:mm:ss"
                                                                ).diff(
                                                                    moment(
                                                                        moment
                                                                            .utc(tip.created_at)
                                                                            .format("HH:mm:ss a"),
                                                                        "HH:mm:ss"
                                                                    )
                                                                )
                                                            )
                                                            .format("HH") == "00"
                                                            ? `${moment
                                                                .utc(
                                                                    moment(
                                                                        moment.utc().format("HH:mm:ss a"),
                                                                        "HH:mm:ss"
                                                                    ).diff(
                                                                        moment(
                                                                            moment
                                                                                .utc(tip.created_at)
                                                                                .format("HH:mm:ss a"),
                                                                            "HH:mm:ss"
                                                                        )
                                                                    )
                                                                )
                                                                .format("mm")} mins`
                                                            : `${moment
                                                                .utc(
                                                                    moment(
                                                                        moment.utc().format("HH:mm:ss a"),
                                                                        "HH:mm:ss"
                                                                    ).diff(
                                                                        moment(
                                                                            moment
                                                                                .utc(tip.created_at)
                                                                                .format("HH:mm:ss a"),
                                                                            "HH:mm:ss"
                                                                        )
                                                                    )
                                                                )
                                                                .format("HH:mm")} mins`}

                                              </span>
                                                </Col>
                                                <Col md="3" sm="3" className="p-0">
                                                    <p
                                                        className="text-right poundValue">
                                                        {tip.amount_formatted}
                                                    </p>
                                                </Col>
                                            </Row>
                                        </Media>
                                    </Media>
                                </div>
                            ))}
                        </div>
                    </Container>
                </div>
            </div>
        )
    }
}


